/* FOLLIVA INSTRUMENT — header: sticky, mobile drawer, search toggle */
(function () {
  "use strict";
  var FL = window.FL || {};
  FL.ready = FL.ready || function (f) { document.readyState !== "loading" ? f() : document.addEventListener("DOMContentLoaded", f); };

  /* Sticky hide-on-scroll-down / show-on-scroll-up */
  customElements.define("fl-header", class extends (FL.Element || HTMLElement) {
    init() {
      var mode = this.getAttribute("data-sticky");
      if (mode === "none") return;
      /* The sticky element is the Shopify section WRAPPER, not <fl-header> (a sticky box can
         only move within its parent, and the element's parent is only header-height). So the
         hide/stick classes must land on the wrapper for the transform to take effect. */
      var target = this.closest('[id^="shopify-section"]') || this;
      var lastY = window.scrollY, ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (mode === "scroll-up") {
            if (y > lastY && y > 200) target.classList.add("is-hidden");
            else target.classList.remove("is-hidden");
          }
          target.classList.toggle("is-stuck", y > 8);
          /* Publish the header's live pinned height so sticky sub-headers (e.g. the compare
             table's column row) can sit flush under it — 0 when the header is hidden, so no
             gap opens above them on scroll-down. */
          var hidden = target.classList.contains("is-hidden");
          document.documentElement.style.setProperty("--fl-header-h", hidden ? "0px" : (target.offsetHeight || 69) + "px");
          lastY = y; ticking = false;
        });
      }
      var off = FL.on ? FL.on(window, "scroll", onScroll, { passive: true }) : (window.addEventListener("scroll", onScroll, { passive: true }));
      if (this.track) this.track(typeof off === "function" ? off : function () { window.removeEventListener("scroll", onScroll); });
    }
  });

  /* Announcement bar — cross-fade between messages.
     The element was being rendered with a data-rotate speed but never defined, so the timer
     never existed: message 1 kept `is-active` forever and every other message sat at
     opacity 0, unreachable. Scroll and stand-still modes emit no data-rotate and need no JS. */
  customElements.define("fl-announce", class extends (FL.Element || HTMLElement) {
    init() {
      var ms = parseInt(this.getAttribute("data-rotate"), 10);
      if (!ms) return;
      var msgs = this.querySelectorAll(".fl-announce__msg");
      if (msgs.length < 2) return;
      var i = 0;
      /* A countdown message removes itself when it runs out, so the set worth rotating
         through is recomputed each step — a snapshot taken at init would keep fading to
         an empty slot where the finished message used to be. */
      function live() {
        return Array.prototype.filter.call(msgs, function (m) { return !m.hidden; });
      }
      function show(list, n) {
        msgs.forEach(function (m) { m.classList.remove("is-active"); });
        if (list[n]) list[n].classList.add("is-active");
      }
      show(live(), 0);
      var timer = setInterval(function () {
        var list = live();
        if (!list.length) return;
        i = (i + 1) % list.length;
        show(list, i);
      }, ms);
      if (this.track) this.track(function () { clearInterval(timer); });
    }
  });

  FL.ready(function () {
    /* Mobile menu drawer */
    var releaseTrap = null;
    function menu() { return document.querySelector("[data-fl-menu]"); }

    /* --- drill-down: the root list and each parent's sub-list are sibling "views", one shown
       at a time. `animate` is false when we silently rewind to root on close, so a reopen
       never replays a slide the user didn't ask for. --- */
    function currentView(m) { return m.querySelector('.fl-menu-drawer__view.is-current'); }
    function showView(m, id, dir, animate) {
      var wrap = m.querySelector("[data-fl-menu-views]"); if (!wrap) return;
      var next = wrap.querySelector('[data-fl-menu-view="' + id + '"]'); if (!next) return;
      wrap.querySelectorAll("[data-fl-menu-view]").forEach(function (v) {
        if (v === next) return;
        v.hidden = true;
        v.classList.remove("is-current", "is-entering", "is-entering-back");
      });
      m.querySelectorAll("[data-fl-menu-open]").forEach(function (b) {
        b.setAttribute("aria-expanded", b.getAttribute("data-fl-menu-open") === id ? "true" : "false");
      });
      next.hidden = false;
      next.classList.add("is-current");
      next.classList.remove("is-entering", "is-entering-back");
      if (animate) {
        void next.offsetWidth; /* restart the keyframes if the same view re-enters */
        next.classList.add(dir === "back" ? "is-entering-back" : "is-entering");
        var focus = next.querySelector("[data-fl-menu-back], a, button");
        if (focus) focus.focus({ preventScroll: true });
      }
      var panel = next.closest(".fl-menu-drawer__panel");
      if (panel) panel.scrollTop = 0;
    }
    function atRoot(m) {
      var cur = currentView(m);
      return !cur || cur.getAttribute("data-fl-menu-view") === "root";
    }

    function openMenu() {
      var m = menu(); if (!m) return;
      m.hidden = false; requestAnimationFrame(function () { m.classList.add("is-open"); });
      document.querySelectorAll("[data-fl-menu-toggle]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      if (FL.lockScroll) FL.lockScroll(true);
      if (FL.trapFocus) releaseTrap = FL.trapFocus(m, { onEscape: onEscape });
    }
    function closeMenu() {
      var m = menu(); if (!m) return;
      m.classList.remove("is-open");
      document.querySelectorAll("[data-fl-menu-toggle]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      if (FL.lockScroll) FL.lockScroll(false);
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      setTimeout(function () {
        if (m.classList.contains("is-open")) return;
        m.hidden = true;
        showView(m, "root", null, false); /* reopen always starts at the top level */
      }, 320);
    }
    /* Escape steps back out of a sub-list first, and only closes from the root. */
    function onEscape() {
      var m = menu(); if (!m) return;
      if (atRoot(m)) closeMenu(); else showView(m, "root", "back", true);
    }

    document.addEventListener("click", function (e) {
      var open = e.target.closest("[data-fl-menu-open]");
      if (open) {
        e.preventDefault();
        var mo = menu(); if (mo) showView(mo, open.getAttribute("data-fl-menu-open"), "fwd", true);
        return;
      }
      var back = e.target.closest("[data-fl-menu-back]");
      if (back) {
        e.preventDefault();
        var mb = menu(); if (mb) showView(mb, "root", "back", true);
        return;
      }
      var t = e.target.closest("[data-fl-menu-toggle]");
      if (t) { e.preventDefault(); var m = menu(); (m && m.classList.contains("is-open")) ? closeMenu() : openMenu(); }
    });

    /* Search toggle */
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-fl-search-toggle]");
      if (!t) return;
      e.preventDefault();
      var s = document.querySelector("[data-fl-search]"); if (!s) return;
      s.hidden = !s.hidden;
      if (!s.hidden) { var inp = s.querySelector("input[type=search]"); if (inp) inp.focus(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var s = document.querySelector("[data-fl-search]"); if (s && !s.hidden) s.hidden = true;
    });
  });
})();
